import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';

import { FinishedStep } from './finished.step';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getFinishedSteps = (flowType?: AppData['flowType']): Step[] => {
  const steps: Step[] = [FinishedStep];
  return steps;
};
